import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MetaTagType } from '@toro/common/shared/enum/seo/meta-tag-type.enum';
import { LoggedDomainGuard } from '@toro/common/shared/guards/logged-domain.guard';
import { CustomPreloader } from "./custom-router-preloader";
import { CheckoutStockGuard } from './guards/checkout-stock.guard';
import { TradingViewGuard } from './guards/trading-view.guard';
import { StockAnalysisComponent } from './partials/stock-analysis/stock-analysis.component';
import { PlannedCheckoutComponent } from './partials/stock/checkout/planned-checkout/planned-checkout.component';
import { UnplannedCheckoutComponent } from './partials/stock/checkout/unplanned-checkout/unplanned-checkout.component';
import { StockHomeComponent } from './partials/stock/stockhome/stockhome.component';
import { ChartWrapperComponent } from './partials/tradingview/tradingview-wrapper.component';

const routes: Routes = [
    {
        path: '',
        component: StockHomeComponent,
        canActivate: [LoggedDomainGuard],
        canActivateChild: [LoggedDomainGuard],
        children: [
            {
                path: '',
                redirectTo: 'explore-o-mercado',
                pathMatch: 'full',
            },

            {
                path: 'investir',
                redirectTo: 'explore-o-mercado',
            },
            {
                path: 'oportunidades',
                redirectTo: 'explore-o-mercado',
            },
            {
                path: 'meus-investimentos',
                loadChildren: './partials/home/my-investments/my-investments.module#MyInvestmentsModule',
                data: {
                    preload: false
                }
            },
            {
                path: 'explore-o-mercado',
                loadChildren: './partials/home/market-explorer/market-explorer.module#MarketExplorerModule',
                data: {
                    preload: true
                }
            }
        ],
    },

    {
        path: 'analise/:symbol', component: StockAnalysisComponent,
        data: {
            opportunityPage: false,
            metaData: {
                title: 'Análise - Bolsa de Valores | Toro Investimentos ',
                metaTags: [
                    { name: MetaTagType.Description, description: 'Veja a análise do ativo e descubra se é um bom momento para investir' },
                ],
            },
        },
    },

    {
        path: 'analise/:symbol/:tendencia', component: StockAnalysisComponent,
        data: {
            opportunityPage: false,
            metaData: {
                title: 'Análise - Bolsa de Valores | Toro Investimentos ',
                metaTags: [
                    { name: MetaTagType.Description, description: 'Veja a análise do ativo e descubra se é um bom momento para investir ' },
                ],
            },
        },
    },

    {
        path: 'oportunidade/:id', component: StockAnalysisComponent,
        data: {
            opportunityPage: true,
            metaData: {
                title: 'Oportunidade - Bolsa | Toro Investimentos',
                metaTags: [
                    {
                        name: MetaTagType.Description,
                        description: 'Veja a oportunidade e descubra se é um bom momento para investir no curto, médio ou longo prazo' },
                ],
            },
        },
    },

    // // Checkout
    { path: 'checkout/planejado',  canActivate: [ CheckoutStockGuard ], component: PlannedCheckoutComponent,
        data: {
            editing: false,
            metaData: {
                title: 'Checkout Planejado - Bolsa de Valores | Toro Investimentos',
            },
        },
    },

    { path: 'checkout/planejado/editar',  canActivate: [ CheckoutStockGuard ], component: PlannedCheckoutComponent,
        data: {
            editing: true,
            metaData: {
                title: 'Checkout Planejado - Bolsa de Valores | Toro Investimentos',
            },
        },
    },

    { path: 'checkout', canActivate: [ CheckoutStockGuard ], component: UnplannedCheckoutComponent,
        data: {
            editing: false,
            metaData: {
                title: 'Checkout - Bolsa de Valores | Toro Investimentos',
            },
        },
    },

    { path: 'checkout/editar', canActivate: [ CheckoutStockGuard ], component: UnplannedCheckoutComponent,
        data: {
            editing: true,
            metaData: {
                title: 'Checkout - Bolsa de Valores | Toro Investimentos',
            },
        },
    },
    {
        path: 'acompanhamento',
        loadChildren: './partials/stock-tracking/stock-tracking.module#StockTrackingModule'
    },
    {
        path: 'checkout-carteira',
        loadChildren: './partials/stock/checkout-wallet/checkout-wallet.module#CheckoutWalletModule',
    },
    {
        path: 'carteiras',
        loadChildren: './partials/investment-portfolio/investment-portfolio.module#InvestmentPortfolioModule',
    },
    {
        path: 'grafico',
        canActivate: [TradingViewGuard],
        component: ChartWrapperComponent
    },
    {
      path: 'grafico/:id',
      canActivate: [TradingViewGuard],
      component: ChartWrapperComponent
    },
    {
        path: 'ofertas-publicas',
        canActivate: [LoggedDomainGuard],
        loadChildren: './partials/stock-ipo/stock-ipo.module#StockIpoModule',
        data: {
            preload: false
        }
    },
    {
        path: 'trader-advisor',
        canActivate: [LoggedDomainGuard],
        loadChildren: './partials/trader-advisor/trader-advisor.module#TraderAdvisorModule',
    },
    {
        path: 'clube-trader',
        canActivate: [LoggedDomainGuard],
        loadChildren: './partials/club-trader/club-trader.module#ClubTraderModule',
    },
];

// Exporta apenas a rota configurada.
@NgModule({
    imports: [RouterModule.forRoot( routes, { preloadingStrategy: CustomPreloader })],
    exports: [RouterModule],
    providers: [CustomPreloader]
})
export class AppRoutingModule { }
